import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ParticipantPriceType } from '@cds/betting-offer';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import {
    RacingParticipantWithEventOption,
    RacingParticipantWithParticipantOption,
    TimeformParticipantWithEventOption,
    TimeformParticipantWithParticipantOption,
} from '@frontend/sports/racing/feature/models';

@Component({
    selector: 'ms-racing-fixture-container',
    templateUrl: './racing-fixture-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class RacingFixtureContainerComponent {
    @Input() runner:
        | RacingParticipantWithEventOption
        | RacingParticipantWithParticipantOption
        | TimeformParticipantWithParticipantOption
        | TimeformParticipantWithEventOption;

    @Input() isSports: boolean;
    @Input() isGreyhounds: boolean;
    @Input() isSpan: boolean;
    @Input() oddsMarketName?: string | null;
    @Input() isOption: boolean;
    @Input() isActive: boolean;
    @Input() isWinMarketOdds: boolean;

    priceType = {
        Fixed: ParticipantPriceType.Fixed,
        StartingPrice: ParticipantPriceType.StartingPrice,
    };

    constructor(public sitecore: Sitecore) {}
}
